import { Spinner } from '@sleepstation/components'
import { offset } from '@sleepstation/style-api-helpers'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: absolute;
  ${offset(0)}
  z-index: 2;
`

const Inner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const LoadOverlay = () => (
  <Layout>
    <Inner>
      <Spinner />
    </Inner>
  </Layout>
)

export default LoadOverlay
